import React, { useEffect, useState } from "react";
import axios from "axios";
import { Redirect } from "react-router-dom";
import { Modal, Button, Form } from "react-bootstrap";
import MyLoader from "../Spinner/MyLoader";
import SessionManager from "../Utils/SessionManager";
import myToast from "../Utils/MyToast";
import COLORS from "../resources/colors/COLORS";
import "../css/Admin_css/admin-customize.css";

const ACCENT = COLORS.primary_color_shade6 || "#039BE5";
const MODAL_RADIUS = 16;

const MODAL_STYLES = `
  .mdl-change-session-name.modal-dialog {
    margin: 0.75rem auto 1.25rem;
    display: flex;
    align-items: center;
  }
  .mdl-change-session-name .modal-content {
    border: none;
    border-radius: ${MODAL_RADIUS}px;
    overflow: hidden;
    box-shadow: 0 12px 40px rgba(15, 23, 42, 0.18);
  }
  .mdl-change-session-name .form-control {
    border-radius: 10px;
    border: 1px solid #e5e7eb;
  }
  .mdl-change-session-name .modal-header .btn-close {
    filter: brightness(0) invert(1);
    opacity: 0.9;
  }
`;

const MdlChangeSessionName = ({ actionClose, action2, session }) => {
  const [loggedIn] = useState(!!localStorage.getItem("token"));
  const [loading, setLoading] = useState(false);
  const [show, setShow] = useState(true);
  const [sessionName, setSessionName] = useState("");
  const [sessionNameOld, setSessionNameOld] = useState("");
  const [error, setError] = useState("");

  useEffect(() => {
    if (session) {
      setSessionName(session.session_name || "");
      setSessionNameOld(session.session_name || "");
    }
  }, [session]);

  const handleClose = () => {
    setShow(false);
    actionClose();
  };

  const handleSubmit = async () => {
    if (!sessionName.trim()) {
      setError("Please enter a session name.");
      return;
    }

    setError("");
    setLoading(true);

    try {
      const schoolCode = SessionManager.getSchoolCode();
      const staffId = SessionManager.getStaffDetails()?.staff_id;
      if (!staffId) {
        myToast.notify_warning("Staff session not found. Please log in again.");
        return;
      }

      const url =
        process.env.REACT_APP_SERVER_NAME +
        process.env.REACT_APP_TARGET_DIR +
        "changeSessionName.php";

      const response = await axios.get(url, {
        params: {
          school_code: schoolCode,
          staff_id: staffId,
          session_id: session.session_id,
          session_name_old: sessionNameOld,
          session_name_new: sessionName.trim(),
        },
      });

      if (response.data?.api_status === "OK") {
        myToast.notify_success(
          response.data.api_remark || "Session name updated successfully!"
        );
        if (typeof action2 === "function") action2();
        handleClose();
      } else {
        myToast.notify_warning(
          response.data?.api_remark || "Could not update session name."
        );
      }
    } catch (err) {
      console.error("Change session name error:", err);
      myToast.notify_error("An error occurred while updating session name.");
    } finally {
      setLoading(false);
    }
  };

  if (!loggedIn) return <Redirect to="/Login" />;

  return (
    <>
      <style>{MODAL_STYLES}</style>
      <Modal
        show={show}
        onHide={handleClose}
        animation={false}
        size="lg"
        dialogClassName="mdl-change-session-name"
        centered
      >
        <Modal.Header
          closeButton
          style={{
            background: `linear-gradient(135deg, ${ACCENT} 0%, ${COLORS.primary_color_shade7 || "#0288D1"} 100%)`,
            borderBottom: "none",
            color: "#fff",
          }}
        >
          <Modal.Title style={{ fontWeight: 800, color: "#fff" }}>
            <i className="fa fa-pencil" style={{ marginRight: 8 }} />
            Change Session Name
          </Modal.Title>
        </Modal.Header>

        <Modal.Body style={{ paddingTop: 18 }}>
          {loading ? (
            <MyLoader />
          ) : (
            <div className="row g-3">
              <div className="col-md-12">
                <Form.Label style={{ fontWeight: 700, fontSize: 13 }}>
                  Session Name
                </Form.Label>
                <Form.Control
                  type="text"
                  placeholder="e.g. 2026-2027"
                  value={sessionName}
                  onChange={(e) => setSessionName(e.target.value)}
                  autoFocus
                />
                {error && (
                  <div style={{ color: "#dc2626", fontSize: 12, marginTop: 6 }}>
                    {error}
                  </div>
                )}
              </div>
            </div>
          )}
        </Modal.Body>

        <Modal.Footer style={{ borderTop: "1px solid #e5e7eb" }}>
          <div className="d-flex justify-content-end w-100 gap-2">
            <Button variant="light" onClick={handleClose} disabled={loading}>
              Cancel
            </Button>
            <Button
              variant="primary"
              onClick={handleSubmit}
              disabled={loading}
              style={{ background: ACCENT, borderColor: ACCENT, fontWeight: 700 }}
            >
              Save Name
            </Button>
          </div>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default MdlChangeSessionName;
